import React from 'react';
import { connect } from 'react-redux';
import { DBTextFieldObjective, ObjectiveFlag } from '_components';
import styles from './Common.module.css'

class SpecialTestSensationMonofilament extends React.Component {

    render() {
        return (
            <>
                <div className={styles.row}>
                    <span className={styles.flag} />
                    <span className={styles.spacer} />
                    <label className={styles.label}>Monofilament Testing</label>
                </div>
                <div className={styles.row}>
                    <span className={styles.flag} />
                    <span className={styles.spacer} />
                    <span className={styles.label} />
                    <span className={styles.r_header} />
                    <span className={styles.spacer} >R</span>
                    <span className={styles.r_header} />
                    <span className={styles.spacer} />
                    <span className={styles.r_header} />
                    <span className={styles.spacer} >L</span>
                    <span className={styles.r_header} />
                </div>

                <div className={styles.row}>
                    <span className={styles.flag} />
                    <span className={styles.spacer} />
                    <span className={styles.label} />
                    <span className={styles.r_header}>Volar</span>
                    <span className={styles.spacer} />
                    <span className={styles.r_header}>Dorsal</span>
                    <span className={styles.spacer} />
                    <span className={styles.r_header}>Volar</span>
                    <span className={styles.spacer} />
                    <span className={styles.r_header}>Dorsal</span>
                </div>


                <div className={styles.textfield_row}>
                    <ObjectiveFlag
                        className={styles.flag}
                        flagged={this.props.includeFlags !== undefined && this.props.includeFlags === false ? false : this.props.thumbFlagged}
                        mopno={this.props.mopno}
                        flagText='Special Test - Monofilament Testing - Thumb'
                    />
                    <span className={styles.spacer} />
                    <label className={styles.label_indent}>Thumb</label>
                    <DBTextFieldObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPECTESTS'
                        entityKeyColumn='TSNO'
                        entityKeyValue={this.props.tsno}
                        field='TSSENSMONOTHUMBVOLR'
                        className={styles.r}
                    />
                    <span className={styles.spacer} />

                    <DBTextFieldObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPECTESTS'
                        entityKeyColumn='TSNO'
                        entityKeyValue={this.props.tsno}
                        field='TSSENSMONOTHUMBDORR'
                        className={styles.r}
                    />

                    <span className={styles.spacer} />

                    <DBTextFieldObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPECTESTS'
                        entityKeyColumn='TSNO'
                        entityKeyValue={this.props.tsno}
                        field='TSSENSMONOTHUMBVOLL'
                        className={styles.r}
                    />

                    <span className={styles.spacer} />

                    <DBTextFieldObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPECTESTS'
                        entityKeyColumn='TSNO'
                        entityKeyValue={this.props.tsno}
                        field='TSSENSMONOTHUMBDORL'
                        className={styles.r}
                    />

                </div>



                <div className={styles.textfield_row}>
                    <ObjectiveFlag
                        className={styles.flag}
                        flagged={this.props.includeFlags !== undefined && this.props.includeFlags === false ? false : this.props.indexFlagged}
                        mopno={this.props.mopno}
                        flagText='Special Test - Monofilament Testing - Index'
                    />
                    <span className={styles.spacer} />
                    <label className={styles.label_indent}>Index Finger</label>
                    <DBTextFieldObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPECTESTS'
                        entityKeyColumn='TSNO'
                        entityKeyValue={this.props.tsno}
                        field='TSSENSMONOINDEXVOLR'
                        className={styles.r}
                    />
                    <span className={styles.spacer} />

                    <DBTextFieldObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPECTESTS'
                        entityKeyColumn='TSNO'
                        entityKeyValue={this.props.tsno}
                        field='TSSENSMONOINDEXDORR'
                        className={styles.r}
                    />

                    <span className={styles.spacer} />

                    <DBTextFieldObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPECTESTS'
                        entityKeyColumn='TSNO'
                        entityKeyValue={this.props.tsno}
                        field='TSSENSMONOINDEXVOLL'
                        className={styles.r}
                    />

                    <span className={styles.spacer} />

                    <DBTextFieldObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPECTESTS'
                        entityKeyColumn='TSNO'
                        entityKeyValue={this.props.tsno}
                        field='TSSENSMONOINDEXDORL'
                        className={styles.r}
                    />

                </div>





                <div className={styles.textfield_row}>
                    <ObjectiveFlag
                        className={styles.flag}
                        flagged={this.props.includeFlags !== undefined && this.props.includeFlags === false ? false : this.props.middleFlagged}
                        mopno={this.props.mopno}
                        flagText='Special Test - Monofilament Testing - Middle'
                    />
                    <span className={styles.spacer} />
                    <label className={styles.label_indent}>Middle Finger</label>
                    <DBTextFieldObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPECTESTS'
                        entityKeyColumn='TSNO'
                        entityKeyValue={this.props.tsno}
                        field='TSSENSMONOMIDDLEVOLR'
                        className={styles.r}
                    />
                    <span className={styles.spacer} />

                    <DBTextFieldObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPECTESTS'
                        entityKeyColumn='TSNO'
                        entityKeyValue={this.props.tsno}
                        field='TSSENSMONOMIDDLEDORR'
                        className={styles.r}
                    />

                    <span className={styles.spacer} />

                    <DBTextFieldObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPECTESTS'
                        entityKeyColumn='TSNO'
                        entityKeyValue={this.props.tsno}
                        field='TSSENSMONOMIDDLEVOLL'
                        className={styles.r}
                    />

                    <span className={styles.spacer} />

                    <DBTextFieldObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPECTESTS'
                        entityKeyColumn='TSNO'
                        entityKeyValue={this.props.tsno}
                        field='TSSENSMONOMIDDLEDORL'
                        className={styles.r}
                    />

                </div>






                <div className={styles.textfield_row}>
                    <ObjectiveFlag
                        className={styles.flag}
                        flagged={this.props.includeFlags !== undefined && this.props.includeFlags === false ? false : this.props.ringFlagged}
                        mopno={this.props.mopno}
                        flagText='Special Test - Monofilament Testing - Ring'
                    />
                    <span className={styles.spacer} />
                    <label className={styles.label_indent}>Ring Finger</label>
                    <DBTextFieldObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPECTESTS'
                        entityKeyColumn='TSNO'
                        entityKeyValue={this.props.tsno}
                        field='TSSENSMONORINGVOLR'
                        className={styles.r}
                    />
                    <span className={styles.spacer} />

                    <DBTextFieldObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPECTESTS'
                        entityKeyColumn='TSNO'
                        entityKeyValue={this.props.tsno}
                        field='TSSENSMONORINGDORR'
                        className={styles.r}
                    />

                    <span className={styles.spacer} />

                    <DBTextFieldObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPECTESTS'
                        entityKeyColumn='TSNO'
                        entityKeyValue={this.props.tsno}
                        field='TSSENSMONORINGVOLL'
                        className={styles.r}
                    />

                    <span className={styles.spacer} />

                    <DBTextFieldObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPECTESTS'
                        entityKeyColumn='TSNO'
                        entityKeyValue={this.props.tsno}
                        field='TSSENSMONORINGDORL'
                        className={styles.r}
                    />

                </div>






                <div className={styles.textfield_row}>
                    <ObjectiveFlag
                        className={styles.flag}
                        flagged={this.props.includeFlags !== undefined && this.props.includeFlags === false ? false : this.props.smallFlagged}
                        mopno={this.props.mopno}
                        flagText='Special Test - Monofilament Testing - Small'
                    />
                    <span className={styles.spacer} />
                    <label className={styles.label_indent}>Small Finger</label>
                    <DBTextFieldObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPECTESTS'
                        entityKeyColumn='TSNO'
                        entityKeyValue={this.props.tsno}
                        field='TSSENSMONOSMALLVOLR'
                        className={styles.r}
                    />
                    <span className={styles.spacer} />

                    <DBTextFieldObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPECTESTS'
                        entityKeyColumn='TSNO'
                        entityKeyValue={this.props.tsno}
                        field='TSSENSMONOSMALLDORR'
                        className={styles.r}
                    />

                    <span className={styles.spacer} />

                    <DBTextFieldObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPECTESTS'
                        entityKeyColumn='TSNO'
                        entityKeyValue={this.props.tsno}
                        field='TSSENSMONOSMALLVOLL'
                        className={styles.r}
                    />

                    <span className={styles.spacer} />

                    <DBTextFieldObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPECTESTS'
                        entityKeyColumn='TSNO'
                        entityKeyValue={this.props.tsno}
                        field='TSSENSMONOSMALLDORL'
                        className={styles.r}
                    />

                </div>



            </>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let tsno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESPECTESTS)
        .find(key => (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSNTNO === pk && noteType !== 1)));

    let thumbFlagged = false;
    if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSSENSMONOTHUMBVOLR !== null ||
        state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSSENSMONOTHUMBDORR !== null ||
        state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSSENSMONOTHUMBVOLL !== null ||
        state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSSENSMONOTHUMBDORL !== null) {
        thumbFlagged = true;
    }

    let indexFlagged = false;
    if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSSENSMONOINDEXVOLR !== null ||
        state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSSENSMONOINDEXDORR !== null ||
        state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSSENSMONOINDEXVOLL !== null ||
        state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSSENSMONOINDEXDORL !== null) {
        indexFlagged = true;
    }

    let middleFlagged = false;
    if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSSENSMONOMIDDLEVOLR !== null ||
        state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSSENSMONOMIDDLEDORR !== null ||
        state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSSENSMONOMIDDLEVOLL !== null ||
        state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSSENSMONOMIDDLEDORL !== null) {
        middleFlagged = true;
    }

    let ringFlagged = false;
    if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSSENSMONORINGVOLR !== null ||
        state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSSENSMONORINGDORR !== null ||
        state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSSENSMONORINGVOLL !== null ||
        state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSSENSMONORINGDORL !== null) {
        ringFlagged = true;
    }

    let smallFlagged = false;
    if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSSENSMONOSMALLVOLR !== null ||
        state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSSENSMONOSMALLDORR !== null ||
        state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSSENSMONOSMALLVOLL !== null ||
        state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSSENSMONOSMALLDORL !== null) {
        smallFlagged = true;
    }




    return {
        noteId,
        tsno,
        thumbFlagged,
        indexFlagged,
        middleFlagged,
        ringFlagged,
        smallFlagged
    };
}

const connectedSpecialTestSensationMonofilament = connect(mapStateToProps)(SpecialTestSensationMonofilament);
export { connectedSpecialTestSensationMonofilament as SpecialTestSensationMonofilament };


